/**
 * Generated from ch6_p16.fla
 */
export function ch6_p16(this: Ich6_p16) {
	const holly = this.holly;
	if (!holly[0] && holly.elementFactory) {
		holly[0] = holly.elementFactory(0,undefined);
	}
	if (holly[0]) {
		ch6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_holly.call(holly[0] as Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_holly);
		holly[0].x = 606;
		holly[0].y = 768;
		holly[0].width = 550.00;
		holly[0].height = 605.00;
		holly[0].alpha = 1;
		if (holly[0].onLayout) holly[0].onLayout();
	}
	if (!holly[1] && holly.elementFactory) {
		holly[1] = holly.elementFactory(1,undefined);
	}
	if (holly[1]) {
		ch6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p17_holly.call(holly[1] as Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p17_holly);
		holly[1].x = 543;
		holly[1].y = 466;
		holly[1].width = 423.00;
		holly[1].height = 604.00;
		holly[1].alpha = 1;
		if (holly[1].onLayout) holly[1].onLayout();
	}
	const tyler = this.tyler;
	if (!tyler[0] && tyler.elementFactory) {
		tyler[0] = tyler.elementFactory(0,undefined);
	}
	if (tyler[0]) {
		ch6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_tyler.call(tyler[0] as Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_tyler);
		tyler[0].x = 1136.25;
		tyler[0].y = 548;
		tyler[0].width = 156.50;
		tyler[0].height = 331.00;
		tyler[0].alpha = 1;
		if (tyler[0].onLayout) tyler[0].onLayout();
	}
	if (!tyler[1] && tyler.elementFactory) {
		tyler[1] = tyler.elementFactory(1,undefined);
	}
	if (tyler[1]) {
		ch6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p17_tyler.call(tyler[1] as Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p17_tyler);
		tyler[1].x = 1219;
		tyler[1].y = 316.5;
		tyler[1].width = 80.00;
		tyler[1].height = 143.00;
		tyler[1].alpha = 1;
		if (tyler[1].onLayout) tyler[1].onLayout();
	}
	const letters = this.letters;
	if (!letters[0] && letters.elementFactory) {
		letters[0] = letters.elementFactory(0,undefined);
	}
	if (letters[0]) {
		ch6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtextr_1.call(letters[0] as Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtextr_1);
		letters[0].x = 875.75;
		letters[0].y = 291.25;
		letters[0].width = 48.50;
		letters[0].height = 77.50;
		letters[0].alpha = 1;
		if (letters[0].onLayout) letters[0].onLayout();
	}
	if (!letters[1] && letters.elementFactory) {
		letters[1] = letters.elementFactory(1,undefined);
	}
	if (letters[1]) {
		ch6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtextr_2.call(letters[1] as Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtextr_2);
		letters[1].x = 920.75;
		letters[1].y = 307;
		letters[1].width = 50.50;
		letters[1].height = 98.00;
		letters[1].alpha = 1;
		if (letters[1].onLayout) letters[1].onLayout();
	}
	if (!letters[2] && letters.elementFactory) {
		letters[2] = letters.elementFactory(2,undefined);
	}
	if (letters[2]) {
		ch6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtextr.call(letters[2] as Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtextr);
		letters[2].x = 969.5;
		letters[2].y = 328.25;
		letters[2].width = 36.00;
		letters[2].height = 71.50;
		letters[2].alpha = 1;
		if (letters[2].onLayout) letters[2].onLayout();
	}
	if (!letters[3] && letters.elementFactory) {
		letters[3] = letters.elementFactory(3,undefined);
	}
	if (letters[3]) {
		ch6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtexti_1.call(letters[3] as Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtexti_1);
		letters[3].x = 1001.75;
		letters[3].y = 344.25;
		letters[3].width = 20.50;
		letters[3].height = 58.50;
		letters[3].alpha = 1;
		if (letters[3].onLayout) letters[3].onLayout();
	}
	if (!letters[4] && letters.elementFactory) {
		letters[4] = letters.elementFactory(4,undefined);
	}
	if (letters[4]) {
		ch6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtexti.call(letters[4] as Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtexti);
		letters[4].x = 1021.75;
		letters[4].y = 358.25;
		letters[4].width = 8.50;
		letters[4].height = 53.50;
		letters[4].alpha = 1;
		if (letters[4].onLayout) letters[4].onLayout();
	}
	if (!letters[5] && letters.elementFactory) {
		letters[5] = letters.elementFactory(5,undefined);
	}
	if (letters[5]) {
		ch6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtextn_1.call(letters[5] as Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtextn_1);
		letters[5].x = 1045.5;
		letters[5].y = 353.5;
		letters[5].width = 25.00;
		letters[5].height = 47.00;
		letters[5].alpha = 1;
		if (letters[5].onLayout) letters[5].onLayout();
	}
	if (!letters[6] && letters.elementFactory) {
		letters[6] = letters.elementFactory(6,undefined);
	}
	if (letters[6]) {
		ch6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtextn.call(letters[6] as Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtextn);
		letters[6].x = 1072.5;
		letters[6].y = 372.25;
		letters[6].width = 22.00;
		letters[6].height = 43.50;
		letters[6].alpha = 1;
		if (letters[6].onLayout) letters[6].onLayout();
	}
	if (!letters[7] && letters.elementFactory) {
		letters[7] = letters.elementFactory(7,undefined);
	}
	if (letters[7]) {
		ch6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtextg_1.call(letters[7] as Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtextg_1);
		letters[7].x = 1096.75;
		letters[7].y = 373.5;
		letters[7].width = 18.50;
		letters[7].height = 37.00;
		letters[7].alpha = 1;
		if (letters[7].onLayout) letters[7].onLayout();
	}
	if (!letters[8] && letters.elementFactory) {
		letters[8] = letters.elementFactory(8,undefined);
	}
	if (letters[8]) {
		ch6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtextg_2.call(letters[8] as Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtextg_2);
		letters[8].x = 1116.75;
		letters[8].y = 377.5;
		letters[8].width = 14.50;
		letters[8].height = 29.00;
		letters[8].alpha = 1;
		if (letters[8].onLayout) letters[8].onLayout();
	}
	if (!letters[9] && letters.elementFactory) {
		letters[9] = letters.elementFactory(9,undefined);
	}
	if (letters[9]) {
		ch6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtextg.call(letters[9] as Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtextg);
		letters[9].x = 1132;
		letters[9].y = 380.75;
		letters[9].width = 10.00;
		letters[9].height = 19.50;
		letters[9].alpha = 1;
		if (letters[9].onLayout) letters[9].onLayout();
	}
	const rain = this.rain;
	if (!rain[0] && rain.elementFactory) {
		rain[0] = rain.elementFactory(0,undefined);
	}
	if (rain[0]) {
		ch6_p16_hh_ch6_72dpi_p016017psdAssetrainoverlayrain2.call(rain[0] as Ich6_p16_hh_ch6_72dpi_p016017psdAssetrainoverlayrain2);
		rain[0].x = 839.75;
		rain[0].y = 379.25;
		rain[0].width = 1648.50;
		rain[0].height = 758.50;
		rain[0].alpha = 1;
		if (rain[0].onLayout) rain[0].onLayout();
	}
	if (!rain[1] && rain.elementFactory) {
		rain[1] = rain.elementFactory(1,undefined);
	}
	if (rain[1]) {
		ch6_p16_hh_ch6_72dpi_p016017psdAssetrainoverlayrain1.call(rain[1] as Ich6_p16_hh_ch6_72dpi_p016017psdAssetrainoverlayrain1);
		rain[1].x = 842.75;
		rain[1].y = 384;
		rain[1].width = 1600.50;
		rain[1].height = 768.00;
		rain[1].alpha = 1;
		if (rain[1].onLayout) rain[1].onLayout();
	}
	const bg = this.bg;
	ch6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_bg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const handPhone = this.handPhone;
	ch6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p17_handphone.call(this.handPhone);
	handPhone.x = 574.5;
	handPhone.y = 767.5;
	handPhone.width = 279.00;
	handPhone.height = 328.00;
	handPhone.alpha = 1.00;
	if (handPhone.onLayout) handPhone.onLayout();
	const frameRight = this.frameRight;
	ch6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_wcframeRframe.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 356.00;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const linesRight = this.linesRight;
	ch6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_wcframeLayer584.call(this.linesRight);
	linesRight.x = 1664;
	linesRight.y = 484;
	linesRight.width = 166.00;
	linesRight.height = 520.00;
	linesRight.alpha = 1.00;
	if (linesRight.onLayout) linesRight.onLayout();
	const frameLeft = this.frameLeft;
	ch6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_wcframeLframe.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 344.00;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	const linesLeft = this.linesLeft;
	ch6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_wcframeLayer585.call(this.linesLeft);
	linesLeft.x = 0;
	linesLeft.y = 427.75;
	linesLeft.width = 100.00;
	linesLeft.height = 302.50;
	linesLeft.alpha = 1.00;
	if (linesLeft.onLayout) linesLeft.onLayout();
	return this;
}
function ch6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_bg(this: Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p16_bg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_holly(this: Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_holly) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p16_holly", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_tyler(this: Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_tyler) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p16_tyler", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtextr_1(this: Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtextr_1) {
	if (this.setLayoutTexture) this.setLayoutTexture("r_1", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtextr_2(this: Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtextr_2) {
	if (this.setLayoutTexture) this.setLayoutTexture("r_2", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtextr(this: Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtextr) {
	if (this.setLayoutTexture) this.setLayoutTexture("r", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtexti_1(this: Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtexti_1) {
	if (this.setLayoutTexture) this.setLayoutTexture("i_1", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtexti(this: Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtexti) {
	if (this.setLayoutTexture) this.setLayoutTexture("i", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtextn_1(this: Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtextn_1) {
	if (this.setLayoutTexture) this.setLayoutTexture("n_1", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtextn(this: Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtextn) {
	if (this.setLayoutTexture) this.setLayoutTexture("n", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtextg_1(this: Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtextg_1) {
	if (this.setLayoutTexture) this.setLayoutTexture("g_1", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtextg_2(this: Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtextg_2) {
	if (this.setLayoutTexture) this.setLayoutTexture("g_2", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtextg(this: Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtextg) {
	if (this.setLayoutTexture) this.setLayoutTexture("g", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p17_handphone(this: Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p17_handphone) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p17_handphone", 0.000, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p17_tyler(this: Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p17_tyler) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p17_tyler", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p17_holly(this: Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p17_holly) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p17_holly", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p16_hh_ch6_72dpi_p016017psdAssetrainoverlayrain2(this: Ich6_p16_hh_ch6_72dpi_p016017psdAssetrainoverlayrain2) {
	if (this.setLayoutTexture) this.setLayoutTexture("rain2", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("overlay");
	return this;
}
function ch6_p16_hh_ch6_72dpi_p016017psdAssetrainoverlayrain1(this: Ich6_p16_hh_ch6_72dpi_p016017psdAssetrainoverlayrain1) {
	if (this.setLayoutTexture) this.setLayoutTexture("rain1", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_wcframeRframe(this: Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_wcframeRframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Rframe", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_wcframeLayer584(this: Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_wcframeLayer584) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer584", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_wcframeLframe(this: Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_wcframeLframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Lframe", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_wcframeLayer585(this: Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_wcframeLayer585) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer585", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
interface Ich6_p16Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich6_p16Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich6_p16Sprite extends Ich6_p16Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich6_p16Text extends Ich6_p16Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich6_p16Polygon extends Array<number> {
}
interface Ich6_p16 {
	readonly holly: Ich6_p16Array<Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_holly|Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p17_holly>;
	readonly tyler: Ich6_p16Array<Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_tyler|Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p17_tyler>;
	readonly letters: Ich6_p16Array<Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtextr_1|Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtextr_2|Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtextr|Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtexti_1|Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtexti|Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtextn_1|Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtextn|Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtextg_1|Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtextg_2|Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtextg>;
	readonly rain: Ich6_p16Array<Ich6_p16_hh_ch6_72dpi_p016017psdAssetrainoverlayrain2|Ich6_p16_hh_ch6_72dpi_p016017psdAssetrainoverlayrain1>;
	readonly bg: Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_bg;
	readonly handPhone: Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p17_handphone;
	readonly frameRight: Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_wcframeRframe;
	readonly linesRight: Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_wcframeLayer584;
	readonly frameLeft: Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_wcframeLframe;
	readonly linesLeft: Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_wcframeLayer585;
}
interface Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_bg extends Ich6_p16Sprite {
}
interface Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_holly extends Ich6_p16Sprite {
}
interface Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_tyler extends Ich6_p16Sprite {
}
interface Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtextr_1 extends Ich6_p16Sprite {
}
interface Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtextr_2 extends Ich6_p16Sprite {
}
interface Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtextr extends Ich6_p16Sprite {
}
interface Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtexti_1 extends Ich6_p16Sprite {
}
interface Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtexti extends Ich6_p16Sprite {
}
interface Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtextn_1 extends Ich6_p16Sprite {
}
interface Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtextn extends Ich6_p16Sprite {
}
interface Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtextg_1 extends Ich6_p16Sprite {
}
interface Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtextg_2 extends Ich6_p16Sprite {
}
interface Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_ringtextg extends Ich6_p16Sprite {
}
interface Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p17_handphone extends Ich6_p16Sprite {
}
interface Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p17_tyler extends Ich6_p16Sprite {
}
interface Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p17_holly extends Ich6_p16Sprite {
}
interface Ich6_p16_hh_ch6_72dpi_p016017psdAssetrainoverlayrain2 extends Ich6_p16Sprite {
}
interface Ich6_p16_hh_ch6_72dpi_p016017psdAssetrainoverlayrain1 extends Ich6_p16Sprite {
}
interface Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_wcframeRframe extends Ich6_p16Sprite {
}
interface Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_wcframeLayer584 extends Ich6_p16Sprite {
}
interface Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_wcframeLframe extends Ich6_p16Sprite {
}
interface Ich6_p16_hh_ch6_72dpi_p016017psdAssetchp6_p16_wcframeLayer585 extends Ich6_p16Sprite {
}
